import React from "react";
import "./ScheduleShell.css";

const Pulse = ({ className = "" }) => (
  <div className={`schedule-sk-pulse ${className}`} />
);

/** Full page placeholder while rostering settings load */
export const SchedulePageSkeleton = () => (
  <div className='schedule-shell schedule-shell--page px-5 py-4'>
    <div className='schedule-toolbar schedule-toolbar--elevated mb-4 px-4 py-5'>
      <div className='flex flex-wrap items-end gap-4'>
        <div className='flex flex-col gap-2'>
          <Pulse className='h-2.5 w-12' />
          <Pulse className='h-10 w-[148px] rounded-[10px]' />
        </div>
        <div className='flex flex-col gap-2'>
          <Pulse className='h-2.5 w-24' />
          <Pulse className='h-10 w-[260px] rounded-[10px]' />
        </div>
        <Pulse className='h-10 w-[240px] rounded-[10px]' />
        <div className='schedule-toolbar-actions ml-auto'>
          {Array.from({ length: 7 }).map((_, i) => (
            <Pulse key={i} className='h-7 w-7 rounded-lg' />
          ))}
        </div>
      </div>
    </div>
    <ScheduleCalendarSkeleton rows={8} cols={8} />
    <div className='mt-4 flex justify-center gap-2'>
      {Array.from({ length: 4 }).map((_, i) => (
        <Pulse key={i} className='h-8 w-32 rounded-[10px]' />
      ))}
    </div>
  </div>
);

/** Calendar grid placeholder (week/fortnight/daily shared look) */
export const ScheduleCalendarSkeleton = ({ rows = 7, cols = 8 }) => (
  <div className='schedule-calendar-surface schedule-calendar-skeleton overflow-hidden'>
    <div className='flex border-b border-slate-200 bg-slate-50 px-3 py-3'>
      <Pulse className='mr-3 h-10 w-[150px] shrink-0 rounded-[10px]' />
      <div className='flex min-w-0 flex-1 gap-1.5'>
        {Array.from({ length: cols }).map((_, i) => (
          <div key={i} className='flex flex-1 flex-col items-center gap-1'>
            <Pulse className='h-2 w-8' />
            <Pulse className='h-4 w-6' />
          </div>
        ))}
      </div>
    </div>
    <div className='divide-y divide-slate-100'>
      {Array.from({ length: rows }).map((_, row) => (
        <div key={row} className='flex items-center px-3 py-3'>
          <div className='mr-3 flex w-[150px] shrink-0 items-center gap-2.5'>
            <Pulse className='h-8 w-8 shrink-0 rounded-full' />
            <div className='min-w-0 flex-1 space-y-1.5'>
              <Pulse className='h-2.5 w-28' />
              <Pulse className='h-2 w-16' />
            </div>
          </div>
          <div className='flex min-w-0 flex-1 gap-1.5'>
            {Array.from({ length: cols }).map((_, col) => (
              <div
                key={col}
                className='flex h-12 flex-1 items-center justify-center rounded-md bg-slate-50'
              >
                {(row + col) % 3 === 0 && (
                  <Pulse className='h-7 w-[78%] rounded-md' />
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

/** Compact pulse used for infinite-scroll “load more” */
export const ScheduleLoadMoreSkeleton = () => (
  <div className='flex flex-col items-center gap-2 py-6'>
    <div className='flex w-full max-w-lg gap-2 px-4'>
      <Pulse className='h-10 w-10 shrink-0 rounded-full' />
      <Pulse className='h-10 flex-1 rounded-[10px]' />
    </div>
    <span className='text-xs font-semibold tracking-wide text-slate-400'>
      Loading more…
    </span>
  </div>
);

export default SchedulePageSkeleton;
